import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import {
  type WeeklyReadingSearch,
  weeklyReadingSearchSchema,
} from '../../../features/projects/status-reports/search'
import { WeeklyReadingPage } from '../../../features/projects/status-reports/weekly-reading-page'

/** The director's weekly reading of status reports (P7): projects.read, the projects in scope. */
export const Route = createFileRoute('/_app/projects/status-reports')({
  staticData: { crumb: 'projectStatusReports' },
  validateSearch: (search: Record<string, unknown>): WeeklyReadingSearch =>
    weeklyReadingSearchSchema.parse(search),
  beforeLoad: ({ context }) => requirePermission(context.session, 'projects.read'),
  component: WeeklyReadingPage,
})
